import axios from "axios";
axios.defaults.withCredentials = true;
export async function Axios_Get(url, params = {}) {
  try {
    const response = await axios.get(url, { params });
    return response.data;
  } catch (error) {
    console.error("Axios GET Error:", error);
    throw error;
  }
}

export async function Axios_Post(url, data = {}) {
  try {
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.error("Axios POST Error:", error);
    throw error;
  }
}